var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// ../utils/handlerConfig.js
var require_handlerConfig = __commonJS({
  "../utils/handlerConfig.js"(exports2, module2) {
    var originalComponentCf = process.env.COMPONENTS;
    var readApplicationConfig = (config, componentDefinitions = originalComponentCf, options) => {
      const application = {
        pages: {},
        config: {},
        components: {}
      };
      const optionsWithDefaults = Object.assign(
        {},
        {
          // Whether refs should be evaluated as part of the render
          // This should be set to true for all runtime purposes, but false for studio/editing contexts.
          shouldResolveRefs: true
        },
        options
      );
      const { shouldResolveRefs } = optionsWithDefaults;
      const { config: configValue, environmentConfig = {} } = config;
      if (configValue["environment"]) {
        let configSetting = configValue;
        if (environmentConfig[configValue["environment"]]) {
          configSetting = Object.assign(configSetting, environmentConfig[configValue["environment"]]);
          Object.assign(config, structuredClone({ config: { ...configSetting } }));
        }
      }
      Object.assign(application, structuredClone(config));
      const { pages = {}, components: applicationComponents = {} } = application;
      let ctr = 0;
      const allComponentTypesMap = {};
      function createReactElements(node) {
        if (!node) return null;
        ctr += 1;
        let resolvedComponent = node;
        let id = "";
        const isRef = node.type === "ref";
        if (isRef && shouldResolveRefs) {
          const { ref } = node;
          if (ref && applicationComponents[ref]) {
            resolvedComponent = applicationComponents[ref];
            id = ref;
          } else if (!applicationComponents[ref]) {
            console.error(`Could not find ref: ${ref}`);
          }
        }
        const { type = "" } = resolvedComponent;
        if (!resolvedComponent.key) {
          resolvedComponent.key = type.length ? `${type}-${ctr}` : `fragment-${ctr}`;
        }
        if (type) {
          if (type !== "Fragment") {
            allComponentTypesMap[type] = true;
          }
          if (id) {
            resolvedComponent.id = id;
          }
        }
        let resolvedType = !type ? "Fragment" : type;
        const { type: _, children = [], ...props } = resolvedComponent;
        const componentDefinition = componentDefinitions[type];
        const childElements = (children || []).map(createReactElements);
        const processProps = (props2, propDefinition) => {
          Object.keys(propDefinition).forEach((key) => {
            if (props2[key] && propDefinition[key].type === "array" && Array.isArray(props2[key])) {
              const propItems = propDefinition[key].items || {};
              if (propItems && propItems.type === "slot") {
                props2[key] = props2[key].map((arraySlot) => createReactElements(arraySlot));
              } else {
                props2[key].forEach((item, index) => {
                  if (typeof item === "object") {
                    props2[key][index] = processProps(item, propItems.properties || {});
                  }
                });
              }
            } else if (props2[key] && propDefinition[key].type === "object" && typeof props2[key] === "object") {
              props2[key] = processProps(props2[key], propDefinition[key].properties || {});
            } else if (props2[key] && propDefinition[key].type === "slot" && Array.isArray(props2[key]?.children)) {
              props2[key].children = props2[key].children.map((child) => createReactElements(child));
            }
          });
          return props2;
        };
        let newProps = {};
        if (props) {
          const { inputProps = {} } = componentDefinition || {};
          newProps = structuredClone(props);
          if (inputProps && Object.keys(inputProps).length) {
            processProps(newProps, inputProps);
          }
        }
        const resolvedConfig = resolvedType !== "Fragment" ? Object.assign({}, newProps) : newProps;
        return {
          type: resolvedType,
          props: {
            ...resolvedConfig,
            ...isRef ? { refComponent: node.ref } : {}
          },
          children: childElements,
          __isComponent: true
        };
      }
      Object.keys(pages).forEach((page) => {
        pages[page].elements = pages[page].components.map((rootComponent) => {
          return createReactElements(rootComponent);
        });
      });
      Object.keys(applicationComponents).forEach((name) => {
        const component = applicationComponents[name];
        applicationComponents[name] = createReactElements(component);
      });
      return Object.assign(application, {
        allComponentTypes: Object.keys(allComponentTypesMap)
      });
    };
    var isValidValue = (value) => value !== void 0 && value !== null;
    module2.exports = {
      readApplicationConfig,
      isValidValue
    };
  }
});

// ../core/constants.js
var require_constants = __commonJS({
  "../core/constants.js"(exports2, module2) {
    var LOCK_CORE_DEPENDENCIES = {
      "@ant-design/cssinjs": "1.23.0",
      react: "18.3.1",
      "react-dom": "18.3.1"
    };
    var CORE_DEPENDENCIES2 = {
      semver: "^7.6.3",
      lodash: "^4.17.21",
      "@ant-design/icons": "^5.3.7",
      antd: "^5.17.4",
      "react-error-boundary": "^4.0.13",
      "react-router-dom": "6.23.1",
      "@ungap/structured-clone": "^1.2.0",
      dayjs: "^1.11.10",
      "@auth0/auth0-spa-js": "^2.1.3",
      liquidjs: "^10.10.0",
      jsonata: "^2.0.5",
      uuid: "^10.0.0",
      axios: "^1.7.4",
      "object-hash": "^3.0.0",
      ...LOCK_CORE_DEPENDENCIES
    };
    var CACHE_DIR = "/tmp/cache";
    module2.exports = {
      CORE_DEPENDENCIES: CORE_DEPENDENCIES2,
      CACHE_DIR
    };
  }
});

// ../core/plugins/constants.js
var require_constants2 = __commonJS({
  "../core/plugins/constants.js"(exports2, module2) {
    var INTERNAL_PACKAGES = ["utils"];
    var NPM_SERVICE_URL2 = "https://" + process.env.CPM_DOMAIN;
    var NPM_BUCKET_URL2 = "https://" + process.env.CPM_PUBLIC_BUCKET + ".s3.ap-southeast-2.amazonaws.com";
    var NODE_BUILTINS = [
      "assert",
      "assert/strict",
      "async_hooks",
      "buffer",
      "child_process",
      "cluster",
      "console",
      "constants",
      "crypto",
      "dgram",
      "diagnostics_channel",
      "dns",
      "dns/promises",
      "domain",
      "events",
      "fs",
      "fs/promises",
      "http",
      "http2",
      "https",
      "inspector",
      "inspector/promises",
      "module",
      "net",
      "os",
      "path",
      "path/posix",
      "path/win32",
      "perf_hooks",
      "process",
      "punycode",
      "querystring",
      "readline",
      "readline/promises",
      "repl",
      "stream",
      "stream/consumers",
      "stream/promises",
      "stream/web",
      "string_decoder",
      "timers",
      "timers/promises",
      "tls",
      "trace_events",
      "tty",
      "url",
      "util",
      "util/types",
      "v8",
      "vm",
      "wasi",
      "worker_threads",
      "zlib",
      "debug",
      "canvas"
    ];
    module2.exports = {
      INTERNAL_PACKAGES,
      NPM_SERVICE_URL: NPM_SERVICE_URL2,
      NPM_BUCKET_URL: NPM_BUCKET_URL2,
      NODE_BUILTINS
    };
  }
});

// ../utils/index.js
var index_exports = {};
__export(index_exports, {
  ACTION_TYPES: () => ACTION_TYPES,
  AppContext: () => AppContext,
  DEFAULT_NODE_CONTEXT: () => DEFAULT_NODE_CONTEXT,
  DefaultFailback: () => DefaultFailback,
  ErrorDrawer: () => ErrorDrawer,
  NodeContext: () => NodeContext,
  RenderHiddenDiv: () => RenderHiddenDiv,
  assignRef: () => assignRef,
  assignRefToProps: () => assignRefToProps,
  base64ToFile: () => base64ToFile2,
  cacheWrapper: () => cacheWrapper,
  clearCache: () => clearCache,
  components: () => components_exports,
  convertToKebabCase: () => convertToKebabCase,
  dateUtils: () => date_exports,
  downloadFile: () => downloadFile,
  fileToBase64: () => fileToBase64,
  findChildren: () => findChildren,
  flattenChildren: () => flattenChildren,
  forceParseObject: () => forceParseObject,
  generateObject: () => generateObject,
  getAtPath: () => getAtPath,
  getCache: () => getCache,
  getDescriptionTooltip: () => getDescriptionTooltip,
  getElementById: () => getElementById,
  getFileName: () => getFileName2,
  getTokenFromUrl: () => getTokenFromUrl,
  getUser: () => getUser,
  handleApiResponse: () => handleApiResponse,
  handleCallApi: () => handleCallApi,
  hash256: () => hash256,
  initAuth0Sdk: () => initAuth0Sdk,
  initRootElement: () => initRootElement,
  injectParseFormulaIntoRules: () => injectParseFormulaIntoRules,
  injectStyle: () => injectStyle,
  isAuthenticated: () => isAuthenticated,
  isCache: () => isCache,
  isExpression: () => isExpression,
  isNilOrEmpty: () => isNilOrEmpty,
  joinFieldPaths: () => joinFieldPaths,
  jsonParseSafe: () => jsonParseSafe,
  jsonStringifySafe: () => jsonStringifySafe,
  loadRemoteComponent: () => loadRemoteComponent_exports,
  loadStyles: () => loadStyles,
  parseData: () => parseData2,
  processCustomRules: () => processCustomRules,
  safeGet: () => safeGet,
  safeGetBoolean: () => safeGetBoolean,
  safeGetFunction: () => safeGetFunction,
  safeGetString: () => safeGetString,
  setAtPath: () => setAtPath,
  setCache: () => setCache,
  storage: () => storage,
  stringUtils: () => string_exports,
  switchRefToForward: () => switchRefToForward,
  transformContext: () => transformContext,
  transformData: () => transformData,
  tryParseExpression: () => tryParseExpression,
  tryParseFormulaToArray: () => tryParseFormulaToArray,
  tryParseFormulaToInteger: () => tryParseFormulaToInteger,
  tryParseFormulaToNumber: () => tryParseFormulaToNumber,
  tryParseFormulaToString: () => tryParseFormulaToString,
  tryParseFormulaToType: () => tryParseFormulaToType,
  useAppContext: () => useAppContext,
  useErrors: () => useErrors,
  useInterval: () => useInterval,
  useLocalStorage: () => useLocalStorage,
  useMount: () => useMount,
  useNodeContext: () => useNodeContext,
  usePrimitiveAppContext: () => usePrimitiveAppContext,
  useResizeObserver: () => useResizeObserver,
  useResponsiveStyle: () => useResponsiveStyle,
  verifyToken: () => verifyToken2,
  withErrorBoundary: () => withErrorBoundary
});
module.exports = __toCommonJS(index_exports);

// ../utils/cache.js
var import_get = __toESM(require("lodash/get"));
var import_set = __toESM(require("lodash/set"));
var import_object_hash = __toESM(require("object-hash"));
var cache = {};
var setCache = (path, value) => {
  (0, import_set.default)(cache, path, value);
};
var getCache = (path, defaultValue = void 0) => {
  return (0, import_get.default)(cache, path, defaultValue);
};
var isCache = (path, cacheVersion) => {
  const value = getCache(path);
  if (!value) return false;
  return value.cacheVersion === cacheVersion;
};
var clearCache = (path) => {
  return setCache(path, null);
};
var cacheWrapper = (fn, shouldGetCache = (cache2) => cache2) => {
  return async (...args) => {
    const key = (0, import_object_hash.default)({
      functionName: fn.name,
      args
    });
    const cache2 = getCache(key);
    if (shouldGetCache(cache2)) {
      return cache2;
    }
    const result = await fn(...args);
    setCache(key, result);
    return result;
  };
};

// ../utils/lodashUtils.js
var import_get2 = __toESM(require("lodash/get"));
var import_isNil = __toESM(require("lodash/isNil"));
var import_isEmpty = __toESM(require("lodash/isEmpty"));
var import_defaultTo = __toESM(require("lodash/defaultTo"));
var import_isFunction = __toESM(require("lodash/isFunction"));
var safeGet = (obj, path, defaultValue) => {
  const value = (0, import_get2.default)(obj, path);
  return (0, import_defaultTo.default)(value, defaultValue);
};
var safeGetString = (obj, path, defaultValue) => {
  const value = (0, import_get2.default)(obj, path);
  const result = (0, import_defaultTo.default)(value, defaultValue);
  if (typeof result !== "string") return defaultValue;
  return result;
};
var safeGetBoolean = (obj, path, defaultValue) => {
  const value = (0, import_get2.default)(obj, path);
  const result = (0, import_defaultTo.default)(value, defaultValue);
  if (typeof result !== "boolean") return defaultValue;
  return result;
};
var isNilOrEmpty = (value) => {
  return (0, import_isNil.default)(value) || (0, import_isEmpty.default)(value);
};
var safeGetFunction = (obj, path, defaultValue) => {
  const value = (0, import_get2.default)(obj, path);
  const result = (0, import_defaultTo.default)(value, defaultValue);
  if ((0, import_isFunction.default)(result)) return result;
  return defaultValue;
};

// ../utils/jsonParseSafe.js
var jsonParseSafe = (json, reviver) => {
  try {
    return JSON.parse(json, reviver);
  } catch (error) {
    console.error("\u{1F680} ~ jsonParseSafe ~ error:", error);
    return {};
  }
};
var forceParseObject = (styles = {}) => {
  let stylesObject = styles ?? {};
  if (typeof stylesObject === "object") {
    return stylesObject;
  } else if (typeof stylesObject === "string") {
    try {
      return JSON.parse(stylesObject);
    } catch (error) {
      console.error(`\u{1F680} ~ forceParseObject ~ error:`, error);
      return {};
    }
  } else {
    return {};
  }
};

// ../utils/jsonStringifySafe.js
function jsonStringifySafe(obj, replacer, spaces) {
  try {
    return JSON.stringify(obj, replacer, spaces);
  } catch (err) {
    console.error(err);
    return "{}";
  }
}

// ../utils/componentUtils.jsx
var import_react = __toESM(require("react"));
var import_find = __toESM(require("lodash/find"));
var import_InfoCircleOutlined = __toESM(require("@ant-design/icons/InfoCircleOutlined"));
var findChildren = (children, componentName) => {
  return (0, import_find.default)(children, (item) => {
    return safeGetString(item, "props.__componentName", "") === componentName;
  });
};
var flattenChildren = (children) => {
  return import_react.default.Children.toArray(children).reduce((flattened, child) => {
    if (child.type === import_react.default.Fragment) {
      return flattened.concat(flattenChildren(child.props.children));
    }
    return flattened.concat(child);
  }, []);
};
var getDescriptionTooltip = (description, popupContainerRef) => {
  if (!description) return null;
  return {
    icon: /* @__PURE__ */ import_react.default.createElement(import_InfoCircleOutlined.default, null),
    getPopupContainer: () => popupContainerRef && popupContainerRef.current,
    title: description
  };
};
var RenderHiddenDiv = import_react.default.forwardRef((_, ref) => {
  return /* @__PURE__ */ import_react.default.createElement("div", { ref, style: { display: "none" } });
});

// ../utils/state.js
var import_react2 = require("react");
var AppContext = (0, import_react2.createContext)({});
var getAtPath = (obj, path, defValue) => {
  if (!path) return void 0;
  const pathArray = Array.isArray(path) ? path : path.match(/([^[.\]])+/g);
  const result = pathArray.reduce((prevObj, key) => prevObj && prevObj[key], obj);
  return result === void 0 ? defValue : result;
};
var setAtPath = (obj, path, value) => {
  let baseSchema = Object.assign({}, obj);
  let schema = baseSchema;
  if (path.length === 0) {
    Object.assign(schema, value);
  } else {
    const pList = path.split(".");
    const len = pList.length;
    for (let i = 0; i < len - 1; i++) {
      const elem = pList[i];
      if (!schema[elem]) schema[elem] = {};
      schema = schema[elem];
    }
    schema[pList[len - 1]] = value;
  }
  return baseSchema;
};
var DEFAULT_NODE_CONTEXT = {
  isStudio: false
};
var NodeContext = (0, import_react2.createContext)(DEFAULT_NODE_CONTEXT);

// ../utils/error-utils/components/ErrorDrawer.jsx
var import_drawer = __toESM(require("antd/es/drawer"));
var import_flex = __toESM(require("antd/es/flex"));
var import_typography2 = __toESM(require("antd/es/typography"));
var import_float_button = __toESM(require("antd/es/float-button"));
var import_react9 = __toESM(require("react"));

// ../utils/error-utils/utils.js
var safeGetError = (error) => {
  return {
    message: error?.message || "",
    stacks: (error.stack || error.stacktrace || "").split("\n"),
    timestamp: /* @__PURE__ */ new Date()
  };
};
var handleError = (rawError) => {
  globalErrors.setError(rawError);
};

// ../utils/error-utils/constants.js
var isError = function(e) {
  return e && e.message;
};
var GlobalErrors = class {
  errors = [];
  constructor() {
    this.errors = [];
  }
  setError = (rawError) => {
    if (!isError(rawError)) return;
    const error = safeGetError(rawError);
    this.errors.unshift(error);
    if (this.errors.length > 15) {
      this.errors.shift();
    }
  };
};
var globalErrors = new GlobalErrors();

// ../utils/error-utils/components/ErrorItem.jsx
var import_react3 = __toESM(require("react"));
var import_collapse = __toESM(require("antd/es/collapse"));
var import_space = __toESM(require("antd/es/space"));
var import_typography = __toESM(require("antd/es/typography"));
var { Text } = import_typography.default;
function ErrorItem({ message = "", stacks = [], timestamp }) {
  return /* @__PURE__ */ import_react3.default.createElement(
    import_collapse.default,
    {
      size: "small",
      items: [
        {
          key: "1",
          label: /* @__PURE__ */ import_react3.default.createElement(Text, null, /* @__PURE__ */ import_react3.default.createElement(Text, { style: { color: "#d9d9d9" } }, timestamp.toLocaleString(), " - "), /* @__PURE__ */ import_react3.default.createElement(Text, { type: "danger" }, "Error:", " ", /* @__PURE__ */ import_react3.default.createElement(Text, { type: "danger", style: { fontWeight: "bold" } }, message))),
          children: /* @__PURE__ */ import_react3.default.createElement(import_space.default, { direction: "vertical", size: "small" }, stacks.map((item) => /* @__PURE__ */ import_react3.default.createElement(Text, { style: { color: "#595959" } }, item)))
        }
      ]
    }
  );
}

// ../utils/error-utils/components/ErrorDrawer.jsx
var import_WarningOutlined = __toESM(require("@ant-design/icons/WarningOutlined"));
var import_CloseOutlined = __toESM(require("@ant-design/icons/CloseOutlined"));

// ../utils/hooks/useResizeObserver.js
var import_react4 = require("react");
var useResizeObserver = (ref, callback, dependencies = []) => {
  (0, import_react4.useEffect)(() => {
    const resizeObserver = new ResizeObserver(callback);
    if (ref.current) {
      resizeObserver.observe(ref.current);
    }
    return () => {
      resizeObserver.disconnect();
    };
  }, [callback, ...dependencies || []]);
};

// ../utils/hooks/useMount.js
var import_react5 = require("react");
var useMount = () => {
  const [isMount, setIsMount] = (0, import_react5.useState)(false);
  (0, import_react5.useEffect)(() => {
    setIsMount(true);
  }, []);
  return isMount;
};

// ../utils/hooks/useInterval.js
var import_react6 = require("react");
var useInterval = (callback, delay) => {
  const savedCallback = (0, import_react6.useRef)();
  (0, import_react6.useEffect)(() => {
    savedCallback.current = callback;
  }, [callback]);
  (0, import_react6.useEffect)(() => {
    if (delay !== null) {
      const tick = () => savedCallback.current();
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
};

// ../utils/hooks/useNodeContext.js
var import_react7 = require("react");
var useNodeContext = () => {
  const context = (0, import_react7.useContext)(NodeContext);
  if (context === void 0) {
    return DEFAULT_NODE_CONTEXT;
  }
  return context;
};

// ../utils/hooks/useAppContext.js
var import_react8 = require("react");
var import_omit = __toESM(require("lodash/omit"));
var filterNonJsonableKeys = (obj) => {
  if (typeof obj === "object" && obj !== null) {
    if (Array.isArray(obj)) {
      return obj.map((item) => filterNonJsonableKeys(item)).filter((item) => item !== void 0);
    }
    if ((0, import_react8.isValidElement)(obj) || obj.childNodes instanceof NodeList) {
      return void 0;
    }
    const filterObj = {};
    for (const key in obj) {
      const value = filterNonJsonableKeys(obj[key]);
      if (value !== void 0) {
        filterObj[key] = value;
      }
    }
    return filterObj;
  } else if (obj === null || typeof obj === "string" || typeof obj === "number" || typeof obj === "boolean") {
    return obj;
  } else {
    return void 0;
  }
};
var useAppContext = () => {
  const context = (0, import_react8.useContext)(AppContext);
  if (context === void 0) {
    throw new Error("Please wrap your component inside AppContext");
  }
  return context;
};
var usePrimitiveAppContext = (excludedKeys = ["initialConfig", "components"]) => {
  const context = useAppContext();
  const actualAppContext = filterNonJsonableKeys((0, import_omit.default)(context.appContext, excludedKeys));
  return { ...context, actualAppContext };
};

// ../utils/error-utils/components/useErrors.js
var useErrors = () => {
  const { updateContext, appContext } = useAppContext();
  const isShowWarningIcon = appContext?.state?.errors?.isShowWarningIcon ?? false;
  const setShowWarningIcon = (value) => {
    if (isShowWarningIcon === value) return;
    updateContext("state.errors.isShowWarningIcon", value);
  };
  const setError = (error) => {
    if (Array.isArray(error)) {
      error.map((err) => globalErrors.setError(err));
    } else {
      globalErrors.setError(error);
    }
    setShowWarningIcon(true);
  };
  return {
    isShowWarningIcon,
    setShowWarningIcon,
    setError
  };
};

// ../utils/error-utils/components/ErrorDrawer.jsx
var { Text: Text2 } = import_typography2.default;
function ErrorDrawer() {
  const [open, setOpen] = (0, import_react9.useState)(false);
  const showDrawer = () => {
    setOpen(true);
  };
  const onCloseDrawer = () => {
    setOpen(false);
  };
  const { isShowWarningIcon, setShowWarningIcon } = useErrors();
  const onClickCloseIcon = () => {
    setShowWarningIcon(false);
  };
  const errorMessage = globalErrors.errors.length === 0 ? `You don't have any error` : `An error occurred!`;
  return /* @__PURE__ */ import_react9.default.createElement(import_react9.default.Fragment, null, isShowWarningIcon ? /* @__PURE__ */ import_react9.default.createElement(import_react9.default.Fragment, null, /* @__PURE__ */ import_react9.default.createElement(
    import_float_button.default,
    {
      danger: true,
      icon: /* @__PURE__ */ import_react9.default.createElement(import_WarningOutlined.default, null),
      type: "default",
      style: { bottom: 30, right: 30 },
      onClick: showDrawer
    }
  ), /* @__PURE__ */ import_react9.default.createElement(
    import_CloseOutlined.default,
    {
      onClick: onClickCloseIcon,
      style: { position: "absolute", bottom: 65, right: 30, width: 10, height: 10, zIndex: 100 }
    }
  )) : null, /* @__PURE__ */ import_react9.default.createElement(
    import_drawer.default,
    {
      title: "Exceptions",
      closeIcon: true,
      placement: "bottom",
      closable: false,
      open,
      key: "bottom",
      getContainer: false,
      onClose: onCloseDrawer
    },
    /* @__PURE__ */ import_react9.default.createElement(import_flex.default, { vertical: true, gap: 4 }, /* @__PURE__ */ import_react9.default.createElement(Text2, { style: { color: "#2f54eb" } }, errorMessage), globalErrors.errors.map((item, index) => /* @__PURE__ */ import_react9.default.createElement(ErrorItem, { key: index + item.message, ...item })))
  ));
}

// ../utils/error-utils/components/DefaultFailback.jsx
var import_react10 = __toESM(require("react"));
var import_ReloadOutlined = __toESM(require("@ant-design/icons/ReloadOutlined"));
var import_button = __toESM(require("antd/es/button"));
var import_flex2 = __toESM(require("antd/es/flex"));
var import_typography3 = __toESM(require("antd/es/typography"));
var { Text: Text3 } = import_typography3.default;
function DefaultFailback({ message = "", onRetry = () => {
} }) {
  return /* @__PURE__ */ import_react10.default.createElement(import_react10.default.Fragment, null, /* @__PURE__ */ import_react10.default.createElement(import_flex2.default, { style: { padding: "4px" }, gap: 4 }, /* @__PURE__ */ import_react10.default.createElement(Text3, { type: "danger" }, "Error:", " ", /* @__PURE__ */ import_react10.default.createElement(Text3, { type: "danger", style: { fontWeight: "bold" } }, message)), /* @__PURE__ */ import_react10.default.createElement(import_button.default, { size: "small", shape: "circle", icon: /* @__PURE__ */ import_react10.default.createElement(import_ReloadOutlined.default, null), onClick: onRetry })));
}

// ../utils/error-utils/withErrorBoundary.jsx
var import_react_error_boundary2 = require("react-error-boundary");

// ../utils/error-utils/components/ErrorFailback.jsx
var import_react11 = __toESM(require("react"));
var import_react_error_boundary = require("react-error-boundary");
function ErrorFailback({ error: rawError }) {
  const error = safeGetError(rawError);
  const { resetBoundary } = (0, import_react_error_boundary.useErrorBoundary)();
  const { setShowWarningIcon } = useErrors();
  (0, import_react11.useEffect)(() => {
    setShowWarningIcon(true);
  }, []);
  const handleClickRetry = () => {
    setShowWarningIcon(false);
    resetBoundary();
  };
  return /* @__PURE__ */ import_react11.default.createElement(DefaultFailback, { message: error.message, onRetry: handleClickRetry });
}

// ../utils/error-utils/withErrorBoundary.jsx
function withErrorBoundary(component) {
  return (0, import_react_error_boundary2.withErrorBoundary)(component, {
    FallbackComponent: ErrorFailback,
    onError: handleError
  });
}

// ../utils/formula.js
var import_liquidjs = require("liquidjs");

// ../utils/formulaFilters.js
function liquidjsPluralize(Liquid2) {
  this.registerFilter("pluralize", (n, singular, plural) => pluralize(n, singular, plural));
}
function pluralize(n, singular, plural = null) {
  const num = Number(n);
  if (num === 1) {
    return singular;
  } else if (plural === null) {
    return `${singular}s`;
  } else {
    return plural;
  }
}
function liquidjsAssignProperty(Liquid2) {
  this.registerFilter("assign_prop", (obj, key, value) => assignProperty(obj, key, value));
}
function assignProperty(obj, key, value) {
  return Object.assign({}, obj, { [key]: value });
}
function liquidjsGroupBy(Liquid2) {
  this.registerFilter("group_by", (list, key) => groupBy(list, key));
}
function groupBy(list = [], key) {
  const items = {};
  list.forEach((item) => {
    const itemKey = item[key] || "";
    if (!items[itemKey]) {
      items[itemKey] = [];
    }
    items[itemKey].push(item);
  });
  return Object.keys(items).map((groupKey) => ({ name: groupKey, items: items[groupKey] }));
}
function liquidjsWhereExp(Liquid2) {
  const liquidInstance = new Liquid2({ cache: true });
  this.registerFilter(
    "where_exp",
    (list, variable, expression) => whereExp(liquidInstance, list, variable, expression)
  );
}
function whereExp(liquidInstance, list, variable, expression) {
  return list.filter((v) => !!liquidInstance.evalValueSync(expression, { [variable]: v }));
}
function liquidjsNumber(Liquid2) {
  this.registerFilter("format_number_locale", (value) => {
    if (typeof value === "number") {
      return value.toLocaleString();
    }
    return value;
  });
}

// ../utils/formula.js
var import_isInteger = __toESM(require("lodash/isInteger"));
var import_isFinite = __toESM(require("lodash/isFinite"));
var import_isNil2 = __toESM(require("lodash/isNil"));
var engine = new import_liquidjs.Liquid({
  cache: true
});
engine.plugin(liquidjsPluralize);
engine.plugin(liquidjsAssignProperty);
engine.plugin(liquidjsGroupBy);
engine.plugin(liquidjsWhereExp);
engine.plugin(liquidjsNumber);
var FORMULA_REGEX = /^{{([\S\s]*)}}$|^{!(([\S\s]*)!!)?([\S\s]*)!}$/;
var FORMULA_INVALID = /^{{(\.([\S\s]*))|(([\S\s]*)\.)}}$/;
var FORMULA_INVALID_2 = /^[\S\s]*\.{2}[\S\s]*$/;
var cachedTemplates = {};
function isExpression(value, validateOnChange = false) {
  if (typeof value !== "string") {
    return false;
  }
  const matches = value.match(FORMULA_REGEX);
  if (!matches || matches.length < 2) {
    return false;
  }
  if (validateOnChange && (FORMULA_INVALID.test(value) || FORMULA_INVALID_2.test(value))) {
    return false;
  }
  return true;
}
var handlePostProcessing = (template, transformation) => {
  if (transformation === "NormaliseOrderedLists") {
    let htmlContent = template;
    let tempElement = document.createElement("div");
    tempElement.innerHTML = htmlContent;
    let liCounter = 0;
    (tempElement.querySelectorAll("*") || []).forEach((element) => {
      if (element.tagName === "OL") {
        let nestedLiElements = element.querySelectorAll("li");
        let olLiCounter = 0;
        (nestedLiElements || []).forEach((li) => {
          if (li.parentElement === element) {
            olLiCounter++;
          }
        });
        if (liCounter > 0 && !element.hasAttribute("type")) {
          element.setAttribute("start", liCounter + 1);
        }
        liCounter += olLiCounter;
      }
    });
    return tempElement.innerHTML.replace(/>\s+</g, "><").replace(/\s+</g, "<").replace(/>\s+/g, ">").replace(/<\s+/g, "<").replace(/\s+>/g, ">").replace(/\s+$/g, "").replace(/\s{2,}/g, " ").trim();
  } else if (transformation === "ParseJSON") {
    let response = null;
    try {
      response = JSON.parse(template);
    } catch (e) {
      console.error(e);
    }
    return response;
  }
};
function tryParseExpression(value, state) {
  if (!isExpression(value)) {
    return value;
  }
  const matches = value.match(FORMULA_REGEX);
  try {
    const isFormula = typeof matches[1] === "string" && typeof matches[2] === "undefined";
    if (isFormula) {
      const innerFormulaText = matches[1].replaceAll("\n", "");
      return engine.evalValueSync(innerFormulaText, state);
    }
    if (matches.length >= 4 && typeof matches[4] === "string") {
      const innerTemplateText = matches[4].replaceAll("\n", "");
      if (cachedTemplates[innerTemplateText]) {
        const result2 = engine.renderSync(cachedTemplates[innerTemplateText], state);
        if (matches[3]) {
          return handlePostProcessing(result2, matches[3]);
        }
      }
      cachedTemplates[innerTemplateText] = engine.parse(innerTemplateText);
      const result = engine.renderSync(cachedTemplates[innerTemplateText], state);
      if (matches[3]) {
        return handlePostProcessing(result, matches[3]);
      }
      return result;
    }
  } catch (e) {
    console.error(e);
  }
  return value;
}
function parseData2(data, state) {
  if (data === null || typeof data === "undefined") {
    return data;
  }
  if (typeof data === "string") {
    return tryParseExpression(data, state);
  }
  if (Array.isArray(data)) {
    return data.map((el) => parseData2(el, state));
  }
  if (typeof data !== "object") {
    return tryParseExpression(data, state);
  }
  const parsedData = {};
  Object.keys(data).forEach((key) => {
    const value = data[key];
    if (Array.isArray(value)) {
      parsedData[key] = value.map((child) => {
        return parseData2(child, state);
      });
      return;
    }
    if (typeof value === "object") {
      parsedData[key] = parseData2(value, state);
      return;
    }
    if (typeof value === "string") {
      parsedData[key] = tryParseExpression(value, state);
      return;
    }
    parsedData[key] = value;
  });
  return parsedData;
}
var tryParseFormulaToString = (data, state, defaultValue) => {
  const actualValue = parseData2(data, state);
  if (typeof actualValue !== "string") {
    return defaultValue;
  }
  return actualValue;
};
var tryParseFormulaToNumber = (data, state, defaultValue) => {
  const actualValue = parseData2(data, state);
  if (!(0, import_isFinite.default)(actualValue)) {
    return defaultValue;
  }
  return actualValue;
};
var tryParseFormulaToInteger = (data, state, defaultValue) => {
  const actualValue = parseData2(data, state);
  if (!(0, import_isInteger.default)(actualValue)) {
    return defaultValue;
  }
  return actualValue;
};
var tryParseFormulaToArray = (data, state, defaultValue) => {
  const actualValue = parseData2(data, state);
  if (!Array.isArray(actualValue)) {
    return defaultValue;
  }
  return actualValue;
};
var PARSE_MAP = {
  number: tryParseFormulaToNumber,
  integer: tryParseFormulaToInteger,
  string: tryParseFormulaToString,
  array: tryParseFormulaToArray
};
var tryParseFormulaToType = (type, data, state, defaultValue) => {
  const func = safeGet(PARSE_MAP, type, (data2, state2) => parseData2(data2, state2));
  return func(data, state, defaultValue);
};

// ../utils/jsonata.js
var import_jsonata = __toESM(require("jsonata"));
function transformData(data, transform) {
  try {
    const expression = (0, import_jsonata.default)(transform);
    return expression.evaluate(data);
  } catch (e) {
    return transform;
  }
}
function transformContext(transform, context) {
  let payload = null;
  const appContext = { app: context };
  if (transform && transform.length) {
    if (transform.startsWith("{!") && transform.endsWith("!}")) {
      payload = parseData(transform, appContext);
    } else {
      payload = transformData(appContext, transform);
    }
  }
  return payload;
}

// ../utils/api.js
var import_axios = __toESM(require("axios"));
var import_utils4 = require("utils");
var applicationName = process.env.APPLICATION;
var applicationConfig = process.env.APPLICATION_CONFIG;
var handleCallApi = async (data, state, key, body) => {
  try {
    const { transformInput = "", transformOutput = "", outputStatePath = "" } = data;
    const config = (0, import_utils4.parseData)(data.config, {
      ...state,
      ...body
    });
    const outputStatePathTransform = (0, import_utils4.parseData)(outputStatePath, state);
    let payload = { ...config };
    let transformedPayload = null;
    if (transformInput && transformInput.length) {
      if (transformInput.startsWith("{!") && transformInput.endsWith("!}")) {
        transformedPayload = (0, import_utils4.parseData)(transformInput, body);
      } else {
        transformedPayload = await (0, import_utils4.transformData)(body, transformInput);
      }
    }
    if (transformedPayload || body?.data) {
      const requestData = transformedPayload || body.data;
      if (payload?.method?.toUpperCase() === "GET") {
        payload.params = Object.assign({}, payload.params, requestData);
      } else {
        payload.data = requestData;
      }
    }
    if (body?.params) {
      payload.params = Object.assign({}, payload.params, body.params);
    }
    if (payload.data && payload?.headers?.["Content-Type"] === "multipart/form-data") {
      const formData = new FormData();
      Object.keys(payload.data).forEach((key2) => {
        const value = payload.data[key2];
        if (value && typeof value === "object" && value.base64 && value.name) {
          const file = (0, import_utils4.base64ToFile)(value.base64, value.name);
          formData.append(key2, file);
        } else {
          formData.append(key2, value);
        }
      });
      payload.data = formData;
    }
    let response;
    const useBackend = data?.useBackend;
    if (useBackend) {
      const owner = applicationConfig?.owner;
      const baseURL = (0, import_utils4.safeGet)(data, "backendUrl", "/");
      response = await (0, import_axios.default)({
        method: "POST",
        url: `/api/invoke/${applicationName}/${key}`,
        headers: payload.headers,
        data: {
          data: payload.data,
          owner
        },
        params: payload.params,
        baseURL
      });
    } else {
      response = await (0, import_axios.default)(payload, { timeout: 30 });
    }
    const headerContentDisp = response.headers["content-disposition"];
    if (headerContentDisp) {
      const filename = headerContentDisp && headerContentDisp.split("filename=")[1].replace(/["']/g, "");
      const contentType = response.headers["content-type"];
      if (typeof window !== "undefined") {
        const blob = new Blob([response.data], { contentType });
        const href = window.URL.createObjectURL(blob);
        const el = document.createElement("a");
        el.setAttribute("href", href);
        el.setAttribute("download", filename || config && config.filename || "download-file");
        el.click();
        window.URL.revokeObjectURL(blob);
      }
    }
    if (transformOutput && transformOutput.length) {
      const result = await (0, import_utils4.transformData)(Object.assign({}, body, { data: response.data }), transformOutput);
      return {
        key: outputStatePathTransform ? outputStatePathTransform : key,
        data: result,
        response
      };
    }
    return {
      key: outputStatePathTransform ? outputStatePathTransform : key,
      data: response.data,
      response
    };
  } catch (error) {
    console.error(error);
    return error;
  }
};
var handleApiResponse = async (requests, updateContext, authUrl, shouldMerge = false) => {
  const responses = await Promise.all(requests.map((r) => r.catch((e) => e)));
  let errors = [];
  for (let response of responses) {
    if (response instanceof Error) {
      errors.push(response);
    }
    updateContext(response.key, response.data, shouldMerge ? { concat: true } : { replace: true });
  }
  updateContext("isLoaded", true);
  if (errors.length) {
    errors.forEach((error) => {
      console.error(error.message);
      if (error?.response?.status === 401 && authUrl) {
        window.location.href = authUrl;
      }
    });
    throw new Error("Something went wrong. Please screenshot this error, please refresh your browser and try again.");
  }
  return responses.map((r) => r.data);
};
var downloadFile = async (fileUrl, filename) => {
  const response = await (0, import_axios.default)({
    url: fileUrl,
    method: "GET",
    responseType: "blob"
  });
  const blob = new Blob([response.data], {
    type: response.headers["content-type"]
  });
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  if (filename) {
    link.download = filename;
  } else {
    link.download = (0, import_utils4.getFileName)(fileUrl);
  }
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// ../utils/storage.js
var import_react12 = require("react");
var storage = {
  setValue: (key, value) => {
    localStorage.setItem(key, value);
  },
  getValue: (key) => {
    return localStorage.getItem(key) || null;
  },
  deleteValue: (key) => {
    localStorage.removeItem(key);
  }
};
var useLocalStorage = (key, defaultValue) => {
  const [value, setValue] = (0, import_react12.useState)(() => {
    if (typeof window !== "undefined") {
      try {
        const storedValue = localStorage.getItem(key);
        return storedValue === null ? defaultValue : JSON.parse(storedValue);
      } catch (e) {
        return defaultValue;
      }
    }
    return defaultValue;
  });
  (0, import_react12.useEffect)(() => {
    if (typeof window === "undefined") {
      return;
    }
    const listener = (e) => {
      if (e.storageArea === localStorage && e.key === key) {
        setValue(e.newValue ? JSON.parse(e.newValue) : e.newValue);
      }
    };
    window.addEventListener("storage", listener);
    return () => {
      window.removeEventListener("storage", listener);
    };
  }, [key, defaultValue]);
  const setValueInLocalStorage = (newValue) => {
    setValue((currentValue) => {
      const result = typeof newValue === "function" ? newValue(currentValue) : newValue;
      if (typeof window !== "undefined") {
        localStorage.setItem(key, JSON.stringify(result));
        window.dispatchEvent(
          new StorageEvent("storage", {
            storageArea: localStorage,
            key,
            newValue: JSON.stringify(result)
          })
        );
      }
      return result;
    });
  };
  return [value, setValueInLocalStorage];
};

// ../utils/styles.js
var import_isNil3 = __toESM(require("lodash/isNil"));
var import_theme = __toESM(require("antd/es/theme"));
var import_uuid = require("uuid");
var import_cssinjs = require("@ant-design/cssinjs");
var import_react13 = require("react");
function convertToKebabCase(str) {
  return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
var convertStyles = (styles) => Object.entries(styles).filter(([_, v]) => ![null, void 0].includes(v) && String(v).trim() !== "").reduce((acc, [key, value]) => {
  let val = value;
  if (typeof value === "string" && !value.includes("!important")) {
    val = `${value} !important`;
  } else if (typeof value === "number") {
    val = `${value} !important`;
  }
  acc[key] = val;
  return acc;
}, {});
var loadStyles = async (targetRoot, styles = []) => {
  const styleLoadingPromises = styles.map(
    (href) => new Promise((resolve, reject) => {
      const link = document.createElement("link");
      link.setAttribute("rel", "stylesheet");
      link.setAttribute("href", href);
      link.onload = () => resolve(href);
      link.onerror = () => reject(new Error(`Error loading ${href}`));
      targetRoot.appendChild(link);
    })
  );
  await Promise.all(styleLoadingPromises).catch((error) => {
    console.error("Error loading styles:", error);
  });
};
var cacheItems = {};
var hashStyle = (data = {}) => {
  const style = forceParseObject(data);
  const hash2 = JSON.stringify(style);
  if (cacheItems[hash2]) {
    return {
      id: cacheItems[hash2],
      style
    };
  } else {
    const temp = `style-${(0, import_uuid.v4)()}`;
    cacheItems[hash2] = temp;
    return {
      id: temp,
      style
    };
  }
};
var useResponsiveStyle = (_style = {}) => {
  const { token, theme: antdTheme } = import_theme.default.useToken();
  const { isStudio } = useNodeContext();
  const { id: className, style } = (0, import_react13.useMemo)(() => hashStyle(_style), [JSON.stringify(_style)]);
  (0, import_cssinjs.useStyleRegister)(
    {
      theme: antdTheme,
      token,
      path: [className]
    },
    () => {
      const { tablet = {}, desktop = {}, mobile = {}, ...otherProps } = style;
      const otherStyled = convertStyles(otherProps);
      const tabletStyled = convertStyles(tablet);
      const desktopStyled = convertStyles(desktop);
      const mobileStyled = convertStyles(mobile);
      if (isStudio) {
        return {
          [`.${className}`]: {
            ...otherStyled,
            "@container (width < 768px)": mobileStyled,
            "@container (width >= 768px) and (width < 1200px)": tabletStyled,
            "@container (width >= 1200px)": desktopStyled
          }
        };
      }
      return {
        [`.${className}`]: {
          ...otherStyled,
          "@media (max-width: 767px)": mobileStyled,
          "@media (min-width: 768px) and (max-width: 1199px)": tabletStyled,
          "@media (min-width: 1200px)": desktopStyled
        }
      };
    }
  );
  return {
    styled: {},
    className
  };
};
var injectStyle = (styleCtn = "", selectors = "root") => {
  if (!styleCtn) return;
  let containerDiv = document.querySelector(selectors);
  if ((0, import_isNil3.default)(containerDiv)) {
    containerDiv = document.getElementById("root");
  }
  if ((0, import_isNil3.default)(containerDiv)) {
    containerDiv = document.head;
  }
  const styleElement = document.createElement("style");
  styleElement.textContent = styleCtn;
  if (!(0, import_isNil3.default)(containerDiv.shadowRoot)) {
    containerDiv.shadowRoot.appendChild(styleElement);
    return;
  }
  containerDiv.appendChild(styleElement);
};

// ../utils/components.jsx
var components_exports = {};
__export(components_exports, {
  ConditionalFragment: () => ConditionalFragment,
  FormulaWrapper: () => FormulaWrapper,
  NextComponent: () => NextComponent,
  NextComponentErrorBoundary: () => NextComponentErrorBoundary,
  NodeContextProvider: () => NodeContextProvider,
  RootElement: () => RootElement,
  elementToReact: () => elementToReact
});
var import_react14 = __toESM(require("react"));
var import_react_router_dom = require("react-router-dom");
var import_skeleton = __toESM(require("antd/es/skeleton"));
var import_utils5 = require("utils");
var import_notification = __toESM(require("antd/es/notification"));
var import_mergeWith = __toESM(require("lodash/mergeWith"));
var import_isArray = __toESM(require("lodash/isArray"));
var import_structured_clone = __toESM(require("@ungap/structured-clone"));
var import_get3 = __toESM(require("lodash/get"));

// ../utils/refUtils.js
var assignRef = (el, ref) => {
  if (!el) return;
  if (ref && typeof ref === "function") {
    ref(el);
  } else if (ref && "current" in ref) {
    ref.current = el;
  }
};
var assignRefToProps = (props, ref, onRef = (ref2) => {
}) => {
  try {
    return Object.assign({}, props, {
      ref: (el) => {
        assignRef(el, ref);
        onRef(el);
      }
    });
  } catch (error) {
    return props;
  }
};
var switchRefToForward = (parentRef, isStudio = false) => {
  if (isStudio) {
    return {
      studioRef: parentRef,
      componentRef: void 0
    };
  }
  return {
    studioRef: void 0,
    componentRef: parentRef
  };
};

// ../utils/rootElements.js
var import_isNil4 = __toESM(require("lodash/isNil"));
var initRootElement = (element) => {
  if (!(element instanceof Document || element instanceof ShadowRoot || element instanceof Element)) {
    throw new Error("Invalid input: Expected a Document, ShadowRoot, or Element instance.");
  }
  const isShadowContext = (el) => el instanceof ShadowRoot || el.shadowRoot;
  element.getElementsByClassName = function(className) {
    if (isShadowContext(this)) {
      return (this.shadowRoot || this).querySelectorAll(`.${className}`);
    }
    return document.getElementsByClassName(className);
  };
  element.getElementById = function(id) {
    if (isShadowContext(this)) {
      return (this.shadowRoot || this).querySelector(`#${id}`);
    }
    return document.getElementById(id);
  };
  element.getElementsByTagName = function(tagName) {
    if (isShadowContext(this)) {
      return (this.shadowRoot || this).querySelector(tagName);
    }
    return document.getElementsByTagName(tagName);
  };
  element.appendChild = function(child) {
    if (isShadowContext(this)) {
      return ShadowRoot.prototype.appendChild.call(this, child);
    }
    return Element.prototype.appendChild.call(this, child);
  };
  element.querySelector = function(selectors) {
    if (isShadowContext(this)) {
      return ShadowRoot.prototype.querySelector.call(this, selectors);
    }
    return Element.prototype.querySelector.call(this, selectors);
  };
  return element;
};
var getElementById = (id) => {
  if (!id || !document) return null;
  let el = document.getElementById(id);
  if (el) return el;
  const temp = document.getElementsByClassName("unified-react-container");
  if (!temp || temp.length !== 1) {
    return null;
  }
  const container = temp[0];
  if ((0, import_isNil4.default)(container.shadowRoot)) return null;
  return container.shadowRoot.getElementById(id);
};

// ../utils/components.jsx
var version = process.env.UNIFIED_REACT_VERSION;
var applicationConfig2 = process.env.APPLICATION_CONFIG;
var { allComponentTypes: allComponentTypesDefault = [] } = applicationConfig2;
var parseDynamicValues = (startProp, output, keyPath, dynamicProps, componentState, inputPropDefinition = {}, validateOnChange) => {
  if (typeof startProp === "undefined" || startProp === null) {
    return;
  }
  Object.keys(startProp).forEach((key) => {
    if (key === "initialConfig" || key === "children" || key === "form" || inputPropDefinition[key] && inputPropDefinition[key].type === "event") {
      output[key] = startProp[key];
      return;
    }
    if ((0, import_utils5.isExpression)(startProp[key], validateOnChange)) {
      output[key] = (0, import_utils5.parseData)(startProp[key], componentState);
      dynamicProps[keyPath ? `${keyPath}.${key}` : key] = output[key];
    } else if (typeof startProp[key] === "object" && !Array.isArray(startProp[key])) {
      if (startProp[key] === null) {
        output[key] = null;
      } else {
        output[key] = {};
        parseDynamicValues(
          startProp[key],
          output[key],
          key,
          dynamicProps,
          componentState,
          inputPropDefinition,
          validateOnChange
        );
      }
    } else if (Array.isArray(startProp[key])) {
      output[key] = startProp[key].map((el, idx) => {
        if (typeof el === "object") {
          let arrayOutput = {};
          parseDynamicValues(
            el,
            arrayOutput,
            `${key}[${idx}]`,
            dynamicProps,
            componentState,
            inputPropDefinition,
            validateOnChange
          );
          return arrayOutput;
        } else {
          if ((0, import_utils5.isExpression)(el, validateOnChange)) {
            const parsedElement = (0, import_utils5.parseData)(el, componentState);
            dynamicProps[`${key}[${idx}]`] = parsedElement;
            return parsedElement;
          }
          return el;
        }
      });
    } else {
      output[key] = startProp[key];
    }
  });
};
var NextComponent = import_react14.default.forwardRef((props, parentRef) => {
  const {
    ChildComponent,
    enableSkeleton,
    formulaState: parentFormulaState,
    __componentDefinition: { inputProps = {} } = {},
    validateOnChange
  } = props;
  const { appContext, updateContext } = (0, import_utils5.useAppContext)();
  const [hasCorrectState, setHasCorrectState] = (0, import_react14.useState)(typeof parentFormulaState === "undefined");
  (0, import_react14.useEffect)(() => {
    setHasCorrectState(true);
  }, [parentFormulaState]);
  const { initialConfig = {}, propOverrides = {} } = props;
  const componentState = Object.assign(
    {},
    typeof parentFormulaState !== "undefined" ? parentFormulaState : {},
    { app: appContext },
    initialConfig,
    propOverrides
  );
  const dynamicProps = {};
  const nextProps = {};
  parseDynamicValues(props, nextProps, "", dynamicProps, componentState, inputProps, validateOnChange);
  const nextPropsPrimitiveObject = {};
  const nextPropsPrimitives = [];
  Object.keys(nextProps).forEach((key) => {
    if (typeof nextProps[key] !== "object" && typeof nextProps[key] !== "function") {
      nextPropsPrimitives.push(nextProps[key]);
      nextPropsPrimitiveObject[key] = nextProps[key];
    }
  });
  const { nameProp, pathProp, formulaState } = nextProps;
  if (nameProp && pathProp && formulaState) {
    nextProps[nameProp] = (0, import_get3.default)(formulaState, pathProp);
  }
  (0, import_react14.useEffect)(() => {
    if (nextProps.statePath && nextProps.name) {
      const simplifiedName = nextProps.name.startsWith("form.") ? nextProps.name.replace("form.", "") : nextProps.name;
      updateContext(`state.${nextProps.statePath}.${simplifiedName}`, nextPropsPrimitiveObject);
    }
  }, [JSON.stringify(nextPropsPrimitiveObject)]);
  const childRef = (0, import_react14.useRef)();
  const { id } = nextProps;
  (0, import_react14.useEffect)(() => {
    if (childRef && childRef.current && id) {
      updateContext(`components.${id}`, childRef.current);
    }
  }, [childRef]);
  const finalProps = {
    ...nextProps,
    ...propOverrides
  };
  const component = (0, import_react14.useMemo)(() => {
    const propsWithRef = assignRefToProps(finalProps, parentRef, (ref) => childRef.current = ref);
    return import_react14.default.createElement(ChildComponent, propsWithRef);
  }, [JSON.stringify(nextPropsPrimitives), JSON.stringify(dynamicProps), childRef, parentRef]);
  const isClient = typeof window !== "undefined";
  if (enableSkeleton && !hasCorrectState && isClient) {
    return import_react14.default.createElement(import_skeleton.default, {
      active: true,
      paragraph: { rows: 1 }
    });
  }
  return component;
});
var NextComponentErrorBoundary = (0, import_utils5.withErrorBoundary)(NextComponent);
var FormulaWrapper = (ChildComponent, enableSkeleton = true) => {
  const { enableSkeleton: enableSkeletonGlobal } = applicationConfig2;
  let shouldEnableSkeleton = enableSkeleton;
  if (typeof enableSkeletonGlobal !== void 0) {
    shouldEnableSkeleton = enableSkeletonGlobal;
  }
  return (props) => import_react14.default.createElement(NextComponentErrorBoundary, {
    ChildComponent,
    enableSkeleton: shouldEnableSkeleton,
    ...props
  });
};
var ConditionalFragment = (props) => {
  const { visible, children = [] } = props;
  if (visible === false) {
    return null;
  }
  return import_react14.default.createElement(import_react14.default.Fragment, {}, children);
};
var elementToReact = (obj, initialConfig = {}, componentEntrypoints = {}, allComponentTypes, configs = {
  transformProps: null,
  transformRenderType: null,
  transformElement: null
}) => {
  if (typeof window !== "undefined") {
    initialConfig.rootElement = initRootElement(initialConfig.rootElement);
  }
  if (typeof obj === "object" && obj !== null) {
    if (Array.isArray(obj)) {
      return obj.map((item) => elementToReact(item, initialConfig, componentEntrypoints, allComponentTypes, configs));
    } else {
      for (const key in obj) {
        if (key !== "__isComponent" && !(key === "children" && obj.__isComponent) && Object.prototype.hasOwnProperty.call(obj, key)) {
          obj[key] = elementToReact(obj[key], initialConfig, componentEntrypoints, allComponentTypes, configs);
        }
      }
      if (obj.__isComponent) {
        const { type, props, children } = obj;
        let actualType = type;
        if (type === "Fragment") {
          actualType = ConditionalFragment;
        } else {
          if (allComponentTypes.includes(type)) {
            actualType = componentEntrypoints[type] ? componentEntrypoints[type] : ConditionalFragment;
          }
        }
        const renderType = FormulaWrapper(actualType);
        const elementProps = type === "Fragment" ? {
          children,
          key: props.key,
          visible: props.visible
        } : Object.assign({}, props, { initialConfig });
        const transformProps = safeGetFunction(configs, "transformProps", (a) => a);
        const finalProps = transformProps(elementProps, type, actualType);
        const transformRenderType = safeGetFunction(configs, "transformRenderType", (a) => a);
        const finalRenderType = transformRenderType(renderType);
        const UIElementChildrens = elementToReact(
          children,
          initialConfig,
          componentEntrypoints,
          allComponentTypes,
          configs
        );
        const UIElement = import_react14.default.createElement(finalRenderType, finalProps, UIElementChildrens);
        const transformElement = safeGetFunction(configs, "transformElement", (a) => a);
        const FinalUIElement = transformElement(UIElement, finalProps);
        return FinalUIElement;
      }
      return obj;
    }
  }
  return obj;
};
var RootElement = (props) => {
  const {
    applicationConfig: applicationConfig3 = {},
    initialConfig,
    elements = [],
    additionalParams = {},
    componentEntrypoints,
    csr = false,
    events: pageEvents = {},
    allComponentTypes = allComponentTypesDefault,
    isStudio = false
  } = props;
  const { api, dataSource } = applicationConfig3;
  const { rootElement, authUrl = "", disableAPI = false, mockedData = {} } = initialConfig;
  let params = null;
  if (!csr) {
    params = (0, import_react_router_dom.useParams)();
  } else {
    params = additionalParams;
  }
  const navigate = (0, import_react_router_dom.useNavigate)();
  const location = (0, import_react_router_dom.useLocation)();
  const [unloadEvents, setUnloadEvents] = (0, import_react14.useState)([]);
  const [ready, setReady] = (0, import_react14.useState)(false);
  let initialConfigWithParams = Object.assign({}, initialConfig, params, { dataSource });
  let [appContext, setAppContext] = (0, import_react14.useState)({
    initialConfig: initialConfigWithParams,
    callback: {},
    isLoaded: false,
    version,
    components: {}
  });
  const updatedContextRef = (0, import_react14.useRef)(appContext);
  const intervalActionKeyRef = (0, import_react14.useRef)({});
  const safeClone = (value) => {
    if (value == null || typeof value !== "object") return value;
    try {
      return (0, import_structured_clone.default)(value);
    } catch {
      return Array.isArray(value) ? [...value] : { ...value };
    }
  };
  const updateContext = (path = "", newProps, options = {}) => {
    let updatedContext = updatedContextRef.current || appContext;
    const subState = path === "" ? updatedContext : (0, import_utils5.getAtPath)(updatedContext, path);
    if (typeof newProps === "object" && !Array.isArray(newProps)) {
      let clonedNewProps = newProps;
      try {
        clonedNewProps = (0, import_structured_clone.default)(newProps);
      } catch (e) {
      }
      let clonedSubState = subState;
      if (path !== "" && typeof subState === "object" && subState !== null) {
        try {
          clonedSubState = (0, import_structured_clone.default)(subState);
        } catch (e) {
        }
      }
      const { replace = false, concat = false } = options;
      if (replace) {
        if (clonedNewProps === null) {
          delete updatedContext[path];
        } else {
          updatedContext = (0, import_utils5.setAtPath)(updatedContext, path, clonedNewProps);
        }
      } else {
        const mergedSubState = (0, import_mergeWith.default)(
          clonedSubState,
          clonedNewProps,
          (objValue, srcValue) => {
            if (concat && (0, import_isArray.default)(objValue) && (0, import_isArray.default)(srcValue)) {
              return objValue.concat(srcValue);
            }
            return (0, import_isArray.default)(srcValue) ? srcValue : void 0;
          }
        );
        updatedContext = (0, import_utils5.setAtPath)(updatedContext, path, mergedSubState);
      }
    } else {
      const { concat = false } = options;
      if (concat && Array.isArray(subState)) {
        updatedContext = (0, import_utils5.setAtPath)(updatedContext, path, subState.concat(newProps));
      } else {
        updatedContext = (0, import_utils5.setAtPath)(updatedContext, path, newProps);
      }
    }
    updatedContextRef.current = updatedContext;
    setAppContext(updatedContextRef.current);
  };
  (0, import_react14.useEffect)(() => {
    const updatedConfig = Object.assign({}, initialConfig, params, { dataSource });
    updateContext("initialConfig", updatedConfig);
  }, [params]);
  const handleEvent = async (actions = [], formulaState = {}) => {
    let currentContext = updatedContextRef.current || appContext;
    const { components, callback = {} } = currentContext;
    const responses = [];
    for (let i = 0; i < actions.length; i++) {
      currentContext = updatedContextRef.current;
      try {
        const action = (0, import_utils5.parseData)(actions[i], { ...initialConfig, ...formulaState, app: currentContext });
        const {
          target,
          type,
          method,
          conditions = true,
          args = [],
          successMessage = "",
          progressMessage = "",
          params: params2,
          successUrl = "",
          message,
          isLoading = false,
          loadingKey = "",
          body
        } = action;
        if (type === "invoke") {
          const targetInstance = components[target] || {};
          if (targetInstance[method]) {
            await Promise.resolve(targetInstance[method](...args));
          }
        } else if (type === "updateContext") {
          if (action["key"]) {
            const newValue = action?.["value"];
            if (typeof newValue === "string" && newValue === "") {
              updateContext(action["key"], action?.["value"]);
            } else {
              updateContext(action["key"], action?.["value"] || 0);
            }
          }
        } else if (type === "deleteContext") {
          if (action["key"]) {
            updateContext(action["key"], null, { replace: true });
          }
        } else if (type === "updateLocalStorage") {
          if (action["key"]) {
            localStorage.setItem(action["key"], action?.["value"] || "");
          }
        } else if (type === "localStorageToContext") {
          if (action["key"] && localStorage.getItem(action["key"])) {
            let localStorageValue = localStorage.getItem(action["key"]);
            if (typeof localStorageValue === "string" && (localStorageValue[0] === "{" || localStorageValue[0] === "[")) {
              try {
                localStorageValue = JSON.parse(localStorageValue);
              } catch (e) {
                console.error("Unable to load JSON value from local storage:" + e.message + e.stack);
              }
            }
            updateContext(action["key"], localStorageValue);
          }
        } else if (type === "removeLocalStorage") {
          if (action["key"]) {
            localStorage.removeItem(action["key"]);
          }
        } else if (type === "api") {
          const maxCount = args.find((arg) => arg.key === "maxLoop");
          const interval = args.find((arg) => arg.key === "interval");
          let isRetryApi = maxCount && interval;
          const callbackConfig = {};
          const callbackBody = {};
          args.forEach((argument) => {
            const { key, value } = argument;
            callbackConfig[key] = value;
            callbackBody[key] = value;
          });
          if (!conditions) {
            return;
          }
          const targetApi = callback[target];
          if (targetApi) {
            let count = 0;
            let apiCallSuccess = false;
            const apiHandler = async () => {
              const promises = [
                targetApi(
                  callbackConfig,
                  Object.assign(
                    {},
                    { app: updatedContextRef.current },
                    body ? { data: body } : {},
                    params2 ? { params: params2 } : {},
                    callbackBody,
                    formulaState
                  )
                )
              ];
              let progressMessageKey = void 0;
              try {
                if (isLoading) {
                  updateContext("isLoaded", false);
                }
                if (progressMessage) {
                  progressMessageKey = `open${Date.now()}`;
                  toast({ type: "info", key: progressMessageKey, message: progressMessage, duration: 0 });
                }
                loadingKey && updateContext(loadingKey, true);
                const response = await (0, import_utils5.handleApiResponse)(promises, updateContext, authUrl, action["merge"]);
                if (progressMessageKey) {
                  toast({ type: "destroy", key: progressMessageKey });
                }
                if (successMessage) {
                  toast({ type: "success", message: successMessage });
                }
                if (successUrl) {
                  window.location.href = successUrl;
                }
                apiCallSuccess = true;
                return response[0];
              } catch (e) {
                if (isRetryApi) {
                  if (count >= maxCount.value) {
                    updateContext(loadingKey, false);
                    toast({ type: "error", message: `API Error: ${e.message}` });
                  }
                } else {
                  if (progressMessageKey) {
                    toast({ type: "destroy", key: progressMessageKey });
                  }
                  toast({ type: "error", message: `API Error: ${e.message}` });
                }
              } finally {
                if (isRetryApi) {
                  if (count >= maxCount.value) {
                    updateContext(loadingKey, false);
                  }
                } else {
                  loadingKey && updateContext(loadingKey, false);
                }
              }
            };
            if (isRetryApi) {
              for (let j = 0; j < maxCount.value; j++) {
                count++;
                const response = await apiHandler();
                if (apiCallSuccess) {
                  responses.push(response);
                  break;
                }
                await new Promise((resolve) => setTimeout(resolve, interval.value));
              }
            } else {
              responses.push(await apiHandler());
            }
          } else {
            console.error(`Target API: ${target} could not be found!`);
          }
        } else if (type === "confirm") {
          if (!confirm(message)) {
            return false;
          }
        } else if (type === "openLink") {
          const linkArg = args.find((arg) => arg.key === "link");
          if (linkArg.value) {
            window.open(linkArg.value, "_blank");
          }
        } else if (type === "navigate") {
          const linkArg = args.find((arg) => arg.key === "link");
          if (linkArg.value) {
            navigate(linkArg.value);
          }
        } else if (type === "href") {
          const linkArg = args.find((arg) => arg.key === "link");
          if (linkArg.value) {
            window.location.href = window.location.origin + linkArg.value;
          }
        } else if (type === "navigateLink") {
          const linkArg = args.find((arg) => arg.key === "link");
          if (linkArg.value) {
            window.location.href = linkArg.value;
          }
        } else if (type === "download") {
          const linkArg = args.find((arg) => arg.key === "link");
          if (linkArg?.value) {
            const fileNameArg = args.find((arg) => arg.key === "fileName");
            (0, import_utils5.downloadFile)(linkArg.value, fileNameArg?.value || "");
          }
        } else if (type === "ifElse") {
          const { key = "", value = "", formula = "" } = action;
          const { ifTrue = [], ifFalse = [] } = actions[i];
          let isMatch = false;
          if (key !== "" && value !== "") {
            isMatch = (0, import_utils5.getAtPath)(updatedContextRef.current, key) === value;
          } else if (formula !== "") {
            isMatch = formula;
          }
          const actionsToRun = isMatch ? ifTrue : ifFalse;
          await handleEvent(actionsToRun);
        } else if (type === "embedded") {
          if (document) {
            const s = document.createElement("script");
            s.type = "text/javascript";
            s.src = args["application_url"];
            document.body.appendChild(s);
            s.onerror = function() {
              console.log("script not loaded");
            };
            s.onload = function() {
              setTimeout(function() {
                let divEmbeddedSection = document.getElementById(args["embedded_section_id"]);
                if (divEmbeddedSection) {
                  divEmbeddedSection.remove();
                }
                divEmbeddedSection = document.createElement("div");
                divEmbeddedSection.setAttribute("id", args["embedded_section_id"]);
                document.body.appendChild(divEmbeddedSection);
                if (window) {
                  window.UnifiedReact[args["application_name"]].components[args["component_name"]].init({
                    rootElement: divEmbeddedSection,
                    shadow: true,
                    config: action?.["value"]
                  });
                }
              }, 500);
            };
          }
        } else if (type === "scrollToElement") {
          if (document) {
            const elem = document.getElementById(args["key"]);
            if (elem) {
              elem.scrollIntoView({ behavior: "smooth" });
            }
          }
        } else if (type === "callFunction") {
          const functionToCall = (0, import_utils5.getAtPath)(formulaState, method);
          if (typeof functionToCall === "function") {
            functionToCall(...args);
          }
        } else if (type === "copyText") {
          const copyArg = args.find((arg) => arg.key === "text");
          if (copyArg && copyArg.value) {
            navigator.clipboard.writeText(copyArg.value).then(() => {
              toast({ type: "success", message: copyArg.message });
            }).catch((err) => {
              console.error("Failed to copy text: ", err);
            });
          }
        } else if (type === "intervalAction") {
          const { interval, key } = action;
          const { events = [] } = actions[i];
          if (!key) {
            console.error("intervalAction must have a unique key");
            return;
          }
          if (intervalActionKeyRef.current[key]?.intervalId) {
            clearInterval(intervalActionKeyRef.current[key].intervalId);
          }
          if (!interval || Number.isNaN(interval) || interval <= 0) {
            return;
          }
          const validatedInterval = Math.max(Number(interval) || 1e3, 1e3);
          intervalActionKeyRef.current[key] = {
            intervalId: setInterval(async () => {
              if (intervalActionKeyRef.current?.[key]?.isRunning) {
                return;
              }
              intervalActionKeyRef.current[key].isRunning = true;
              try {
                await handleEvent(events);
              } catch (e) {
                console.error(`intervalAction::[${key}] Error when handling events::`, e);
              } finally {
                intervalActionKeyRef.current[key].isRunning = false;
              }
            }, validatedInterval),
            isRunning: false
            // Initialize isRunning to false
          };
        } else if (type === "toast") {
          const { toastType, message: message2, placement } = action;
          toast({ type: toastType, message: message2, placement });
        }
      } catch (e) {
        console.log(e);
        responses.push(false);
        return responses;
      }
    }
    return responses;
  };
  const [notificationInstance, contextHolder] = import_notification.default.useNotification({
    getContainer: () => rootElement
  });
  const toast = ({ type, key = void 0, message = "", duration = 4.5, placement = "" }) => {
    if (type === "destroy") {
      notificationInstance.destroy(key);
    } else {
      notificationInstance[type]({
        key,
        message,
        duration,
        placement: placement || "bottomRight"
      });
    }
  };
  (0, import_react14.useEffect)(() => {
    if (typeof mockedData === "object") {
      const keys = Object.keys(mockedData);
      if (!keys.length) return;
      keys.forEach((e) => {
        updateContext(e, mockedData[e]);
      });
    }
  }, [mockedData]);
  (0, import_react14.useEffect)(() => {
    if (disableAPI) return;
    const url = window?.location?.href;
    const params2 = new URLSearchParams(url.split("#")[1]);
    const accessToken = params2.get("access_token");
    const isValidToken = accessToken && (0, import_utils5.verifyToken)(accessToken);
    if (isValidToken) {
      localStorage.setItem("token", `Bearer ${accessToken}`);
    }
    const isValidTokenLocalStorage = localStorage.getItem("token") && (0, import_utils5.verifyToken)(localStorage.getItem("token"));
    if (!isValidToken && !isValidTokenLocalStorage && authUrl) {
      window.location.href = authUrl;
      return;
    }
    if (applicationConfig3.enableCaching) {
      const childOfApp = applicationConfig3.enableCaching.app;
      for (const key in childOfApp) {
        if (childOfApp.hasOwnProperty(key)) {
          updateContext(`${key}`, childOfApp[key]);
        }
      }
    }
    if (api) {
      const fetch = async () => {
        const entries = Object.entries(api);
        const promises = [];
        const callback = {};
        for (const [key, value] of entries) {
          const clonedValue = (0, import_structured_clone.default)(value);
          const storedToken = localStorage.getItem("token");
          if (storedToken || accessToken) {
            clonedValue.config.headers.authorization = `${storedToken || accessToken}`;
          }
          if (clonedValue?.handle?.includes("init")) {
            if (clonedValue?.enableCaching === false || clonedValue?.enableCaching === void 0) {
              if (clonedValue?.config) {
                promises.push((0, import_utils5.handleCallApi)(value, initialConfigWithParams, key, { app: updatedContextRef.current }));
              }
            }
          } else if (clonedValue?.handle?.includes("initOnce") && !value.hasCalled) {
            if (clonedValue?.enableCaching === false || clonedValue?.enableCaching === void 0) {
              if (clonedValue?.config) {
                value.hasCalled = true;
                promises.push((0, import_utils5.handleCallApi)(value, initialConfigWithParams, key, { app: updatedContextRef.current }));
              }
            }
          }
          if (clonedValue.config) {
            callback[key] = async (callbackConfig, body) => {
              return (0, import_utils5.handleCallApi)(clonedValue, Object.assign({}, initialConfigWithParams, callbackConfig), key, body);
            };
          }
        }
        updateContext("callback", callback);
        try {
          promises.length > 0 && await (0, import_utils5.handleApiResponse)(promises, updateContext, authUrl, false);
        } catch (e) {
          toast({ type: "error", message: `API Error: ${e.message}` });
        }
      };
      fetch().then(() => {
        updatedContextRef.current = (0, import_utils5.setAtPath)(updatedContextRef.current, "initialConfig", initialConfigWithParams);
        const { onload = [], onunload = [] } = pageEvents;
        if (onunload.length) {
          setUnloadEvents(onunload);
        }
        if (typeof window.onFinishLoading === "function") {
          window.onFinishLoading();
        }
        setReady(true);
        return handleEvent(onload);
      });
    } else {
      if (typeof window.onFinishLoading === "function") {
        window.onFinishLoading();
      }
      setReady(true);
      setAppContext({ ...appContext, isLoaded: true });
    }
    if (unloadEvents.length) {
      setUnloadEvents([]);
      handleEvent(unloadEvents);
    }
  }, [location.pathname, disableAPI]);
  const { rootElement: _, ...initialConfigProps } = initialConfigWithParams;
  const elementStrings = isStudio ? "" : JSON.stringify(elements);
  const pageElements = (0, import_react14.useMemo)(() => {
    if (!elementStrings) return elements;
    try {
      const renderedElements = (0, import_structured_clone.default)(elements);
      return elementToReact(renderedElements, initialConfigWithParams, componentEntrypoints, allComponentTypes);
    } catch (e) {
      console.error(e);
    }
  }, [elementStrings, JSON.stringify(initialConfigProps)]);
  if (!ready) {
    return null;
  }
  return import_react14.default.createElement(
    import_utils5.AppContext.Provider,
    { value: { appContext, updateContext, toast, handleEvent } },
    import_react14.default.createElement(import_react14.Fragment, {}, [contextHolder, ...pageElements, /* @__PURE__ */ import_react14.default.createElement(import_utils5.ErrorDrawer, null)])
  );
};
var NodeContextProvider = ({ isStudio = false, children }) => {
  return /* @__PURE__ */ import_react14.default.createElement(import_utils5.NodeContext.Provider, { value: { isStudio } }, children);
};

// ../utils/form.js
var import_isNil5 = __toESM(require("lodash/isNil"));
var generateObject = (field, value) => {
  const fieldPath = field.split(".").reverse();
  const object = {};
  let temp = object;
  while (fieldPath.length > 0) {
    const field2 = fieldPath.pop();
    if (fieldPath.length === 0) {
      temp[field2] = value;
    } else {
      temp[field2] = {};
      temp = temp[field2];
    }
  }
  return object;
};
var injectParseFormulaIntoRules = (rules = [], state = {}) => {
  const INVALID_DEFAULT_VALUE_MAPS = {
    number: {},
    integer: {},
    string: {},
    array: ""
  };
  return rules.map((item) => ({
    ...item,
    transform: (value) => {
      const type = safeGetString(item, "type", "");
      const invalidDefaultValue = safeGet(INVALID_DEFAULT_VALUE_MAPS, "type", "");
      return tryParseFormulaToType(type, value, state, invalidDefaultValue);
    }
  }));
};
var joinFieldPaths = (...fields) => {
  return fields.filter((item) => !(0, import_isNil5.default)(item) && item !== "").join(".").replaceAll(",", ".");
};

// ../utils/params.js
var getTokenFromUrl = () => {
  const url = window?.location?.href;
  const params = new URLSearchParams(url.split("#")[1]);
  return params.get("access_token");
};

// ../utils/index.js
__reExport(index_exports, __toESM(require_handlerConfig()), module.exports);

// ../utils/constant.js
var ACTION_TYPES = {
  invoke: "invoke",
  updateContext: "updateContext",
  api: "api",
  confirm: "confirm",
  openLink: "openLink",
  navigate: "navigate",
  download: "download",
  ifElse: "ifElse"
};

// ../utils/date.js
var date_exports = {};
__export(date_exports, {
  get: () => get3,
  getDayWithFormat: () => getDayWithFormat,
  isDateBefore: () => isDateBefore,
  isValid: () => isValid,
  now: () => now,
  subtract: () => subtract
});
var import_dayjs = __toESM(require("dayjs"));
var now = () => (0, import_dayjs.default)();
var get3 = (value) => (0, import_dayjs.default)(value);
var isValid = (value) => {
  if (!value) return false;
  return (0, import_dayjs.default)(value).isValid();
};
var isDateBefore = (current, checkDate) => (0, import_dayjs.default)(current).isBefore((0, import_dayjs.default)(checkDate));
var subtract = (num, type = "day") => (0, import_dayjs.default)().subtract(num, type);
var getDayWithFormat = (date, format = "YYYY-MM-DD HH:mm:ss") => {
  if (isValid(date)) {
    return get3(date).format(format);
  }
  return "";
};

// ../utils/string.js
var string_exports = {};
__export(string_exports, {
  toSentenceCase: () => toSentenceCase
});
function toSentenceCase(str) {
  const result = str.replace(/([A-Z])/g, " $1").toLowerCase().trim();
  return result.charAt(0).toUpperCase() + result.slice(1);
}

// ../utils/hash.js
var hash256 = async (input) => {
  const textAsBuffer = new TextEncoder().encode(input);
  const hashBuffer = await window.crypto.subtle.digest("SHA-256", textAsBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hash2 = hashArray.map((item) => item.toString(16).padStart(2, "0")).join("");
  return hash2;
};

// ../utils/auth.js
var import_auth0_spa_js = require("@auth0/auth0-spa-js");
var auth0;
var deleteCookie = (name) => {
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};
var initAuth0Sdk = async (domain, clientId, redirectLoginUri) => {
  deleteCookie(`_legacy_auth0.${clientId}.is.authenticated`);
  deleteCookie(`auth0.${clientId}.is.authenticated`);
  auth0 = await (0, import_auth0_spa_js.createAuth0Client)({
    domain,
    clientId,
    authorizationParams: {
      redirect_uri: redirectLoginUri
    }
  });
  return auth0;
};
var getUser = async () => {
  const user = await auth0.getUser();
  return user;
};
var isAuthenticated = () => {
  return auth0.isAuthenticated();
};
var removeQuotes = (str) => {
  if (str.startsWith('"') && str.endsWith('"')) {
    return str.slice(1, -1);
  }
  return str;
};
var getToken = (token) => {
  if (!token) {
    return null;
  }
  if (token.startsWith("Bearer ") || token.startsWith("bearer ")) {
    token = token.substring(7);
  }
  token = removeQuotes(token);
  return token;
};
var parseJwt = (token) => {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    window.atob(base64).split("").map(function(c) {
      return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
    }).join("")
  );
  return JSON.parse(jsonPayload);
};
var verifyToken2 = (token) => {
  if (typeof token !== "string") {
    return false;
  }
  const checkToken = getToken(token);
  const decodedToken = parseJwt(checkToken);
  if (!decodedToken || !decodedToken.exp) {
    return false;
  }
  const currentTime = Math.floor(Date.now() / 1e3);
  return decodedToken.exp > currentTime;
};

// ../utils/file.js
function base64ToFile2(base64, filename) {
  const arr = base64.split(",");
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[arr.length - 1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}
function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
var getFileName2 = (filePath) => {
  const segments = filePath.split(/[\\/]/);
  return segments.pop();
};

// ../utils/loadRemoteComponent.js
var loadRemoteComponent_exports = {};
__export(loadRemoteComponent_exports, {
  CORE_DEPENDENCIES: () => import_constants4.CORE_DEPENDENCIES,
  EXTERNAL_PACKAGES: () => EXTERNAL_PACKAGES,
  NPM_BUCKET_URL: () => import_constants5.NPM_BUCKET_URL,
  NPM_SERVICE_URL: () => import_constants5.NPM_SERVICE_URL,
  createCacheRequest: () => createCacheRequest,
  getComponentInCache: () => getComponentInCache,
  isComponentCached: () => isComponentCached,
  loadComponent: () => loadComponent,
  loadComponentAndCss: () => loadComponentAndCss,
  loadCss: () => loadCss,
  loadDependencies: () => loadDependencies,
  loadFile: () => loadFile
});
var import_react15 = __toESM(require("react"));
var import_react_dom = __toESM(require("react-dom"));
var CssInJs = __toESM(require("@ant-design/cssinjs"));
var jsxRuntime = __toESM(require("react/jsx-runtime"));
var ReactDOMClient = __toESM(require("react-dom/client"));
var import_axios2 = __toESM(require("axios"));
var import_constants4 = __toESM(require_constants());
var import_constants5 = __toESM(require_constants2());
var PackageImports = {};
var createCacheRequest = (params, func, checkSuccess) => {
  const key = JSON.stringify(params);
  let requestPromise = cacheRequestPromise[key];
  if (!requestPromise || params.forceUpdate) {
    requestPromise = (async () => {
      const response = await func(params);
      if (checkSuccess(response)) {
        cacheRequestPromise[key] = null;
      }
      return response;
    })();
    cacheRequestPromise[key] = requestPromise;
  }
  return requestPromise;
};
var defaultRequires = (name) => {
  if (name === "react") {
    return import_react15.default;
  } else if (name === "utils") {
    return index_exports;
  } else if (name === "@ant-design/cssinjs") {
    return CssInJs;
  } else if (name === "react/jsx-runtime") {
    return jsxRuntime;
  } else if (name === "react-dom") {
    return import_react_dom.default;
  } else if (name === "react-dom/client") {
    return ReactDOMClient;
  }
  if (PackageImports.hasOwnProperty(name)) {
    return PackageImports[name];
  }
  throw new Error("Could not require '" + name + "'. The 'requires' function was not provided.");
};
var downloadFile3 = async (url, retries = 3) => {
  for (let attempt = 1; attempt <= retries; attempt++) {
    const delay = 5e3 * attempt;
    try {
      const response = await import_axios2.default.get(url, { responseType: "blob" });
      const text = await response.data.text();
      return text;
    } catch (error) {
      if (attempt < retries) {
        console.warn(`Attempt ${attempt} failed. Retrying in ${delay}ms...`);
        await new Promise((resolve) => setTimeout(resolve, 5e3 * attempt));
      } else {
        throw new Error(`Failed to download file after ${retries} attempts.`);
      }
    }
  }
};
var compileCode = (code) => {
  let exports2 = {};
  let module2 = { exports: exports2 };
  const func = new Function("require", "module", "exports", code);
  func(defaultRequires, module2, exports2);
  return module2.exports;
};
var compileDependenciesBundle = (code) => {
  const exports2 = compileCode(code);
  Object.entries(exports2).forEach(([path, func]) => {
    PackageImports[path] = func;
  });
};
var loadDependencies = async (fileName, bucketUrl = import_constants5.NPM_BUCKET_URL) => {
  try {
    const code = await downloadFile3(`${bucketUrl}/${fileName}.cjs`);
    Object.keys(PackageImports).forEach((key) => {
      delete PackageImports[key];
    });
    compileDependenciesBundle(code);
    return {
      kind: "success"
    };
  } catch (err) {
    return {
      kind: "error",
      message: safeGetString(err, "message", "")
    };
  }
};
var loadFile = async (baseUrl, componentName, fileName, prefixBucketPath) => {
  try {
    const response = await import_axios2.default.post(`${baseUrl}/api/components`, {
      componentName,
      prefixBucketPath,
      fileName
    });
    return response.data;
  } catch (error) {
    return "";
  }
};
var loadCss = async (baseUrl, componentName, prefixBucketPath) => {
  return loadFile(baseUrl, componentName, "dist.csr.index.css", prefixBucketPath);
};
var loadComponent = async (baseUrl, componentName, prefixBucketPath) => {
  try {
    const componentCode = await loadFile(baseUrl, componentName, "dist.csr.index.js", prefixBucketPath);
    if (!componentCode) {
      console.error("Empty component!");
      return {};
    }
    return compileCode(componentCode);
  } catch (error) {
    console.error("Error loading component:", error);
    return {};
  }
};
var isComponentCached = (componentName, cacheVersion) => isCache(`components.${componentName}`, cacheVersion);
var getComponentInCache = (componentName) => getCache(`components.${componentName}`);
var _loadComponentAndCss = async ({
  baseUrl = "",
  componentName,
  prefixBucketPath = "",
  forceUpdate = false,
  cacheVersion = 0
}) => {
  if (!componentName) {
    return {
      kind: "error",
      message: "Invalid props"
    };
  }
  if (isComponentCached(componentName, cacheVersion) && forceUpdate === false) {
    return {
      kind: "success"
    };
  }
  try {
    const result = await Promise.all([
      loadComponent(baseUrl, componentName, prefixBucketPath),
      loadCss(baseUrl, componentName, prefixBucketPath)
    ]);
    const Comp = safeGet(result[0], "default", null);
    if (Comp) {
      setCache(`components.${componentName}`, {
        Comp,
        cacheVersion
      });
      injectStyle(result[1], ".unified-react-container");
      return {
        kind: "success",
        message: ""
      };
    } else {
      return {
        kind: "error",
        message: `Cannot fetch ${componentName}`
      };
    }
  } catch (error) {
    return {
      kind: "error",
      message: `Error fetching component ${componentName}: ${error}`
    };
  }
};
var cacheRequestPromise = {};
var loadComponentAndCss = (params) => {
  return createCacheRequest(params, _loadComponentAndCss, (response) => response.kind !== "success");
};
var EXTERNAL_PACKAGES = ["react", "@ant-design/cssinjs", "react-dom"];

// ../utils/custom.js
var createCustomValidate = (customRule) => {
  return () => ({
    validator(_) {
      const trimmedRule = customRule ? customRule.trim() : "";
      if (trimmedRule === "!") {
        return Promise.resolve();
      }
      return trimmedRule ? Promise.reject(new Error(trimmedRule)) : Promise.resolve();
    }
  });
};
var createResolveValidate = () => {
  return () => ({
    validator(_) {
      return Promise.resolve();
    }
  });
};
var evaluateCustomRules = (customRules) => {
  return customRules.map((customRule) => {
    const trimmedRule = customRule ? customRule.trim() : "";
    return trimmedRule === "";
  });
};
function safeEval(logic) {
  try {
    const func = new Function(`return ${logic};`);
    return func();
  } catch (e) {
    console.error("Error evaluating logic:", e);
    return false;
  }
}
function evaluateLogic(logic, rulesArray) {
  logic = logic.replace(/\bAND\b/g, "&&").replace(/\bOR\b/g, "||").replace(/\bNOT\b/g, "!");
  logic = logic.replace(/[A-Z]+/g, (match) => {
    const index = match.charCodeAt(0) - "A".charCodeAt(0);
    return rulesArray[index] !== void 0 ? rulesArray[index] : false;
  });
  return safeEval(logic);
}
function processCustomRules(customRules, rules, logic) {
  const logicResult = evaluateLogic(logic, evaluateCustomRules(customRules));
  if (logicResult) {
    rules.push(...customRules.map(createResolveValidate()));
  } else {
    rules.push(...customRules.map(createCustomValidate));
  }
  return rules;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ACTION_TYPES,
  AppContext,
  DEFAULT_NODE_CONTEXT,
  DefaultFailback,
  ErrorDrawer,
  NodeContext,
  RenderHiddenDiv,
  assignRef,
  assignRefToProps,
  base64ToFile,
  cacheWrapper,
  clearCache,
  components,
  convertToKebabCase,
  dateUtils,
  downloadFile,
  fileToBase64,
  findChildren,
  flattenChildren,
  forceParseObject,
  generateObject,
  getAtPath,
  getCache,
  getDescriptionTooltip,
  getElementById,
  getFileName,
  getTokenFromUrl,
  getUser,
  handleApiResponse,
  handleCallApi,
  hash256,
  initAuth0Sdk,
  initRootElement,
  injectParseFormulaIntoRules,
  injectStyle,
  isAuthenticated,
  isCache,
  isExpression,
  isNilOrEmpty,
  joinFieldPaths,
  jsonParseSafe,
  jsonStringifySafe,
  loadRemoteComponent,
  loadStyles,
  parseData,
  processCustomRules,
  safeGet,
  safeGetBoolean,
  safeGetFunction,
  safeGetString,
  setAtPath,
  setCache,
  storage,
  stringUtils,
  switchRefToForward,
  transformContext,
  transformData,
  tryParseExpression,
  tryParseFormulaToArray,
  tryParseFormulaToInteger,
  tryParseFormulaToNumber,
  tryParseFormulaToString,
  tryParseFormulaToType,
  useAppContext,
  useErrors,
  useInterval,
  useLocalStorage,
  useMount,
  useNodeContext,
  usePrimitiveAppContext,
  useResizeObserver,
  useResponsiveStyle,
  verifyToken,
  withErrorBoundary
});
